/* eslint-disable no-shadow */
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { intlShape, injectIntl, FormattedMessage } from 'react-intl';
import { Table, Button, Icon, Modal, Tooltip, Select, Row, Col } from 'antd';
import { Permission } from 'components/page/index';
import { FloatingLabelInput, DeleteConfirmDialog, Panel } from 'components/ui/index';
import PERMISSIONS from 'config/app-permission.config';
import { getTreeItemByKey } from 'utils/treeUtil';
import createSocket from 'utils/socketConnect';
import Enums from 'utils/EnumsManager';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';
import { PAGE_ACTION } from 'config/app.config';
import { queryByPaging, queryBySearchKey, deleteUsers, fetchEditUser, setDepartment, setScopeValue, setSearchKey, loginAsUser } from '../flow/action';
import styles from '../users.less';

const cx = classNames.bind(styles);
const { confirm } = Modal;
const { Option } = Select;

const { ScopeTypes } = Enums;
const { All, Active, Inactive } = ScopeTypes;

class usersTableView extends React.Component {
  state = {
    deleteDialogVisible: false,
    deleteId: '',
  }
  componentDidMount() {
    const { scope } = this.props;
    this.renderDataAsScope(scope);
  }

  getExpirationDayMessage = (days) => {
    if (!days) return '';
    return days === -1 ? 'Unlimited' : `${days} days`;
  }

  delete(id) {
    this.setState({
      deleteDialogVisible: true,
      deleteId: id,
    });
  }
  confirmDelete() {
    const {
      deleteUsers, queryByPaging, usersDataTablePagination, scope
    } = this.props;
    deleteUsers(this.state.deleteId, scope, () => {
      this.setState({
        deleteDialogVisible: false,
      });
      const { perPage, currentPage } = usersDataTablePagination;
      queryByPaging(perPage, currentPage, scope);
    });
  }
  handleChange = value => {
    this.props.setSearchKey(value);
  };

  handleSelectChange = (value) => {
    this.renderDataAsScope(value);
    this.props.setScopeValue(value);
  }

  handleLoginAs = userId => {
    const { loginAsUser, history } = this.props;
    loginAsUser(userId, () => {
      createSocket();
      history.push('/');
    });
  }

  addRowClassAsScope = (record, index) => {
    const { scope } = this.props;
    const { deleteId } = this.state;
    if (scope === 'all') {
      const isAnInactiveData = record.deleted_at !== null ? classNames(cx('inactive-color')) : '';
      if (deleteId && index === deleteId) {
        return classNames(cx('inactive-color'));
      }
      return isAnInactiveData;
    } else if (scope === 'inactive') {
      return classNames(cx('inactive-color'));
    }
  }

  handleButtonDisabled = (record) => {
    const { scope } = this.props;
    if (scope === 'all') {
      return record.deleted_at !== null;
    }
    return scope === 'inactive';
  }

  edit(id) {
    const self = this;
    this.props.fetchEditUser(id, (user) => {
      const { id, name } = getTreeItemByKey(self.props.teams, user.team_id);
      self.props.setDepartment({
        department_id: id,
        department_name: name,
      });
      self.props.history.push(`/setup/company-info/users?id=${user.id}&action=${PAGE_ACTION.EDIT}`);
    });
  }

  searchUser(value) {
    const { scope } = this.props;
    this.props.queryBySearchKey(value, scope);
  }

  handleRowClassName = (record, index) => {
    const { deleteId } = this.state;
    if (deleteId && index === deleteId) {
      return classNames(cx('inactive-color'));
    }
  }

  renderDataAsScope = (scope) => {
    const { usersDataTablePagination, queryByPaging } = this.props;
    const { perPage, currentPage } = usersDataTablePagination;
    // initial the page number while displaying type changes
    queryByPaging(perPage, currentPage, scope);
  }

  render() {
    const {
      usersDataTablePagination,
      users,
      history,
      scope,
      queryByPaging,
    } = this.props;

    const { formatMessage } = this.props.intl;

    const ipToolTip = (
      <Tooltip title={(
        <React.Fragment>
          <span>Hint: IP not been restricted: Can login any where</span>
          <br />
          <span>IP Restricted: Based on IP White List permission</span>
        </React.Fragment>
      )}
      >
        <Icon
          type="question-circle"
          className="font-sm ml-sm icon-thinner"
          style={{ verticalAlign: 'middle' }}
        />
      </Tooltip>
    );

    const rightActions = (
      <Permission permission={PERMISSIONS.SETUP_COMPANYPROFILE_USERS_ADD}>
        <Button
          key="addBtn"
          className="btn-ellipse ml-sm"
          size="small"
          icon="user-add"
          onClick={() => {
          history.push('/setup/company-info/users?action=add');
        }}
        >
          {formatMessage({ id: 'global.ui.button.addBtn' }, { actionType: formatMessage({ id: 'global.properNouns.users' }) })}
        </Button>
      </Permission>);

    const columns = [
      {
        title: formatMessage({ id: 'global.ui.table.action' }),
        key: 'id',
        render: record => (
          <span className={cx('btn-group')}>
            <Permission permission={PERMISSIONS.SETUP_COMPANYPROFILE_USERS_UPDATE}>
              <Tooltip title={
                <FormattedMessage id="page.users.actionButtonGroup.editUser" />
              }
              >
                <Button
                  className={cx('btn-background-color')}
                  style={{ border: 'none' }}
                  disabled={this.handleButtonDisabled(record)}
                  shape="circle"
                  size="small"
                  onClick={() => this.edit(record.id)}
                >
                  <Icon type="edit" className={record.deleted_at === null ? classNames(cx('icon-color')) : ''} />
                </Button>
              </Tooltip>
            </Permission>
            <Permission permission={PERMISSIONS.SETUP_COMPANYPROFILE_USERS_DELETE}>
              <Tooltip title={
                <FormattedMessage id="page.users.actionButtonGroup.inactiveUser" />
              }
              >
                <Button
                  className={classNames(cx('btn-background-color', 'btn-background-color-focus'))}
                  style={{ border: 'none' }}
                  disabled={this.handleButtonDisabled(record)}
                  shape="circle"
                  size="small"
                  onClick={() => this.delete(record.id)}
                >
                  <Icon type="stop" className={record.deleted_at === null ? classNames(cx('icon-color')) : ''} />
                </Button>
              </Tooltip>
            </Permission>
            <Permission permission={PERMISSIONS.SETUP_COMPANYPROFILE_USERS_LOGINASUSER}>
              <Tooltip title={
                <FormattedMessage id="page.users.actionButtonGroup.loginAsUser" />
              }
              >
                <Button
                  className={classNames(cx('btn-background-color', 'btn-background-color-focus'))}
                  style={{ border: 'none' }}
                  disabled={this.handleButtonDisabled(record)}
                  shape="circle"
                  size="small"
                  onClick={() => this.handleLoginAs(record.id)}
                >
                  <Icon type="login" className={record.deleted_at === null ? classNames(cx('icon-color')) : ''} />
                </Button>
              </Tooltip>
            </Permission>
          </span>
        ),
      }, {
        title: formatMessage({ id: 'global.properNouns.users' }),
        dataIndex: 'name',
        key: 'name',
      }, {
        title: formatMessage({ id: 'global.properNouns.joinDate' }),
        dataIndex: 'join_date',
        key: 'join_date',
      }, {
        title: formatMessage({ id: 'global.properNouns.department' }),
        dataIndex: 'team.name',
      }, {
        title: formatMessage({ id: 'global.properNouns.leadPageLayout' }),
        dataIndex: 'page_layouts.data.leads.name',
      }, {
        title: formatMessage({ id: 'global.properNouns.accountPageLayout' }),
        dataIndex: 'page_layouts.data.accounts.name',
      },
      {
        title: formatMessage({ id: 'global.properNouns.opportunitiesPageLayout' }),
        dataIndex: 'page_layouts.data.opportunities.name',
      },
      {
        title: <span>{formatMessage({ id: 'page.users.ipRestrict' })}{ipToolTip}</span>,
        dataIndex: 'ip_restrict',
        render: record => (
          Number(record) === 1 ? 'Yes' : 'No'
        ),
      },
      {
        title: formatMessage({ id: 'page.users.onlineStatus' }),
        dataIndex: 'status'
      },
      {
        title: <span>{formatMessage({ id: 'page.users.forceResetPasswordEvery' })}</span>,
        dataIndex: 'password_expires_days',
        render: record => (
          this.getExpirationDayMessage(record)
        )
      },
    ];

    const pagination = {
      defaultCurrent: usersDataTablePagination.currentPage,
      current: usersDataTablePagination.currentPage,
      defaultPageSize: usersDataTablePagination.perPage,
      pageSize: usersDataTablePagination.perPage,
      total: usersDataTablePagination.total,
      size: 'small',
      onChange(page, pageSize) {
        queryByPaging(pageSize, page, scope);
      },
    };


    return (
      <Panel panelTitle={formatMessage({ id: 'global.properNouns.users' })} actionsRight={rightActions} contentClasses="pt-lg pb-lg pl-lg pr-lg">
        <Row type="flex" justify="start" className="mb-md">
          <Col span={3}>
            <Select className="full-width" value={scope} onChange={this.handleSelectChange}>
              {[All, Active, Inactive].map(item => (
                <Option value={item} key={item}>
                  {formatMessage({ id: `page.users.${item}` })}
                </Option>
              ))}
            </Select>
          </Col>
        </Row>
        <FloatingLabelInput
          labelText={formatMessage({ id: 'page.users.searchUser' })}
          handleSearch={(value) => {
            this.searchUser(value);
          }}
          handleChange={this.handleChange}
          withSearch
        />
        <Table dataSource={users} columns={columns} pagination={pagination} className="mt-lg" rowClassName={this.addRowClassAsScope} rowKey="id" size="small" />
        <DeleteConfirmDialog visible={this.state.deleteDialogVisible} onOk={() => this.confirmDelete()} onCancel={() => this.setState({ deleteDialogVisible: false })} inactive={Inactive} >
          <h3>{formatMessage({ id: 'global.ui.dialog.inactiveTitle' })}</h3>
        </DeleteConfirmDialog>
      </Panel>
    );
  }
}
usersTableView.propTypes = {
  intl: intlShape.isRequired,
  queryByPaging: PropTypes.func,
  queryBySearchKey: PropTypes.func,
  fetchEditUser: PropTypes.func.isRequired,
};
const mapStateToProps = ({ setup, global }) => {
  const { users, usersDataTablePagination, searchKey } = setup.users;
  return {
    teams: global.settings.teams,
    users: users.users,
    scope: users.scope,
    searchKey,
    usersDataTablePagination,
  };
};
const mapDispatchToProps = {
  queryByPaging,
  queryBySearchKey,
  deleteUsers,
  fetchEditUser,
  setDepartment,
  setScopeValue,
  setSearchKey,
  loginAsUser,
};
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(injectIntl(usersTableView)));



// WEBPACK FOOTER //
// ./src/views/Setup/Users/container/tableView.jsx